import { STAR1Locales } from '../internationalization/localeHelper';

// To be used as a server-side check only - for client-side see the hook useStar2
// Returns true if the locale is not a Star1 locale
export const isStar2Check = ({ locale }: { locale?: string }) => {
  if (!locale) return false;
  return !STAR1Locales.includes(locale);
};
